const services = [
    {
        id:1,
        sid: "design",
        title: "Design/CAD",
        text: "We provide <strong>precision CAD design services</strong>, turning concepts into manufacturable models. From 3D modeling to detailed engineering drawings, we ensure accuracy, efficiency, and seamless production integration.",
        image: "/images/services/design.png",
        icon: "/images/services/design-icon.png"
    },
    {
        id:2,
        sid: "consulting",
        title: "Consulting",
        text: "Expert consulting services to provide <strong>practical solutions to complex engineering challenges</strong>. Whether you need <strong>design guidance, process optimization, or troubleshooting</strong>, we offer clear, <strong>efficient</strong>, and <strong>innovative</strong> advice to keep your projects on track.",
        image: "/images/services/consulting.png",
        icon: "/images/services/consulting-icon.png"
    },
    {
        id:3,
        sid: "tooling",
        title: "Tooling",
        text: "Design and develop <strong>high-precision tooling</strong> solutions to enhance manufacturing efficiency and product quality. From custom <strong>jigs and fixtures</strong> to advanced cutting tools, our expertise ensures <strong>durability, accuracy</strong>, and seamless production integration.",
        image: "/images/services/tooling.png",
        icon: "/images/services/tooling-icon.png"
    },
    {
        id:4,
        sid: "automation",
        title: "Automation",
        text: "We specialize in <strong>production automation</strong> solutions that enhance <strong>efficiency, reduce downtime, and optimize</strong> workflows. From <strong>robotic systems</strong> to smart manufacturing processes, we design and implement <strong>cutting-edge automation</strong> tailored to your operation's needs.",
        image: "/images/services/automation.png",
        icon: "/images/services/automation-icon.png"
    },
    {
        id:5,
        sid: "molding",
        title: "Molding",
        text: "Design and manufacture <strong>high-precision molds</strong> for efficient and repeatable part production. Our expert solutions ensure <strong>durability, accuracy, and optimized performance</strong> for all types of molding, casting, and other manufacturing processes.",
        image: "/images/services/molding.png",
        icon: "/images/services/molding-icon.png"
    },
    {
        id:6,
        sid: "fabrication",
        title: "Fabrication",
        text: "We provide <strong>precision fabrication services</strong>, crafting high-quality components for a wide range of industries. From custom metalwork to welded assemblies, our expert team ensures <strong>durability, accuracy, and efficiency</strong> in every project.",
        image: "/images/services/fabrication.png",
        icon: "/images/services/fabrication-icon.png"
    },
    
    

]

export default services;